// External Imports
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

// Internal Imports
import { DisclaimerModal } from "../modal/disclaimer-modal/DisclaimerModal";
import { CookiePolicyModal } from "../modal/cookie-policy-modal/CookiePolicyModal";
import { ImpressumModalPreview } from "../modal/impressum-modal/ImpressumModal";
import { PrivacyPolicyModal } from "../modal/privacy-policy-modal/PrivacyPolicyModal";
import { TermsModalPreview } from "../modal/terms-and-condition-modal/TermsModal";

/**
 * Renders global modals based on query params, if present
 */
export const ModalRenderer: React.FC = () => {
    // Get the location and navigate functions from the router
    const navigate = useNavigate();
    const location = useLocation();
    const query = useLocation().search.replace(/^\?/, "");

    // The modals to render based on the query
    const modals = [
        { key: "privacy-policy", Component: PrivacyPolicyModal },
        { key: "terms-and-conditions", Component: TermsModalPreview },
        { key: "disclaimer", Component: DisclaimerModal },
        { key: "impressum", Component: ImpressumModalPreview },
        { key: "cookie-policy", Component: CookiePolicyModal },
    ];

    // State to keep track of which modals are open
    const [modalOpen, setModalOpen] = useState<{ [key: string]: boolean }>({});

    // When the query changes, update the modals that are open
    useEffect(() => {
        if (!localStorage.getItem("cookiesSeen") && query != "cookie-policy") {
            navigate("/?cookie-policy");
        } else {
            const newModalOpen: { [key: string]: boolean } = {};
            modals.forEach(({ key }) => {
                newModalOpen[key] = query === key;
            });
            setModalOpen(newModalOpen);
        }
    }, [query]);

    // Close the modal
    const closeModal = () => {
        navigate(
            {
                pathname: location.pathname,
                search: "",
            },
            { replace: true },
        );
    };

    // Render the modals
    if (modalOpen) {
        return modals.map(({ key, Component }) => {
            if (modalOpen[key]) {
                return <Component key={key} onRequestClose={closeModal} />;
            }
            return null;
        });
    }
    return null;
};
